import { useCallback, useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useLeaderboardLazyQuery } from 'vvs-gotchi-graphql'
import { Text, IconButton, HelpWithQuestionmark, ButtonMenu, ButtonMenuItem, Flex } from 'vvs-uikit'
import Row from 'components/Layout/Row'
import { useTranslation } from 'contexts/Localization'
import { graphqlRarityFromModelDataMap, Rarity } from 'state/vvsgotchi/models'
import { Search } from 'config/constants/paths'
import { formatUrlSearch } from 'utils/urlSearch'
import LeaderboardTable from '../components/LeaderboardTable'
import { rarityToName } from '../config'
import { ButtonMenuWrap } from './styles'

const LeaderboardView = () => {
  const { t } = useTranslation()
  const history = useHistory()

  const [selectedTabIndex, setSelectedTabIndex] = useState(0)
  const selectedRarity = Rarity[Rarity[selectedTabIndex]]

  const [loadData, queryResult] = useLeaderboardLazyQuery()

  const handleSwitchRarity = useCallback(
    (idx: number) => {
      setSelectedTabIndex(idx)
    },
    [setSelectedTabIndex],
  )

  useEffect(() => {
    loadData({
      variables: {
        first: 10,
        filter: {
          rarity: graphqlRarityFromModelDataMap[selectedRarity],
        },
      },
      notifyOnNetworkStatusChange: true,
      fetchPolicy: 'cache-and-network',
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedTabIndex])

  return (
    <>
      <Flex gap="16px" flexDirection="column" px={3} mt={3}>
        <Row mt={3}>
          <Text bold fontSize={20} color="black">
            {t('Leaderboard')}
          </Text>
          <IconButton
            variant="text"
            onClick={() => history.replace({ search: formatUrlSearch(Search.VVS_GOTCHI_LEADERBOARD_FAQ) })}
          >
            <HelpWithQuestionmark width="28px" height="28px" />
          </IconButton>
        </Row>
        <ButtonMenuWrap mb={3}>
          <ButtonMenu isDarkBg scale="sm" activeIndex={selectedTabIndex} onItemClick={(idx) => handleSwitchRarity(idx)}>
            {Object.keys(Rarity)
              .map((r) => {
                const rarityTranslateFn = rarityToName[r]
                return rarityTranslateFn && <ButtonMenuItem key={r}>{rarityTranslateFn(t)}</ButtonMenuItem>
              })
              .filter((el) => Boolean(el))}
          </ButtonMenu>
        </ButtonMenuWrap>
      </Flex>
      <LeaderboardTable {...queryResult} rarity={selectedRarity} />
    </>
  )
}

export default LeaderboardView
